import React, { useEffect, useState } from "react";
import { apiGet, apiPost } from "../../../services/api";
import { useToast } from "../../common/ToastProvider";
import Button from "../../common/Button";
import "./Widgets.css";

type ProsthoCase = {
    id: number;
    patient_name: string;
    patient_id: string;
    patient_phone?: string;
    patient_age?: number;
    patient_gender?: string;
    teeth: string | null;
    stage: string;
    status: string;
    notes?: string;
    created_at: string;
};

export default function AbutmentPrepWidget() {
    const { showToast } = useToast();
    const [cases, setCases] = useState<ProsthoCase[]>([]);
    const [loading, setLoading] = useState(true);

    const loadData = async () => {
        try {
            const data = await apiGet("/api/treatments/prostho/cases?type=FPD&status=Active&stage=Abutment%20Prep");
            if (Array.isArray(data)) {
                setCases(data);
            }
        } catch (e) {
            console.error("Failed to load FPD cases", e);
            showToast({ message: "Failed to load Abutment Prep cases", type: "error" });
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        loadData();
    }, []);

    const markInProgress = async (caseId: number) => {
        try {
            await apiPost(`/api/treatments/prostho/cases/${caseId}/update`, {
                status: "In Progress"
            });
            showToast({ message: "Case marked as In Progress", type: "success" });
            loadData();
        } catch (e) {
            showToast({ message: "Failed to update case status", type: "error" });
        }
    };

    return (
        <div className="mod-card" style={{ minHeight: '200px', display: 'flex', flexDirection: 'column' }}>
            <div style={{ padding: '16px', borderBottom: '1px solid #f1f5f9', display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: '#f8fafc', borderTopLeftRadius: '16px', borderTopRightRadius: '16px' }}>
                <h3 style={{ margin: 0, fontSize: '1.05rem', color: '#0f172a' }}>🦷 Abutment Prep (FPD)</h3>
                <span style={{ fontSize: '0.8rem', background: '#e2e8f0', color: '#475569', padding: '2px 8px', borderRadius: '12px', fontWeight: 600 }}>{cases.length} Queued</span>
            </div>
            <div style={{ padding: '16px', flex: 1, overflowY: 'auto' }}>
                {loading ? (
                    <div style={{ textAlign: 'center', color: '#94a3b8', padding: '20px' }}>Loading...</div>
                ) : cases.length === 0 ? (
                    <div style={{ textAlign: 'center', color: '#94a3b8', padding: '20px', border: '1px dashed #cbd5e1', borderRadius: '8px' }}>
                        No patients waiting for Abutment Prep.
                    </div>
                ) : (
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                        {cases.map(c => (
                            <div key={c.id} style={{ border: '1px solid #e2e8f0', borderRadius: '12px', padding: '12px', background: '#fff' }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '8px' }}>
                                    <strong style={{ color: '#0f172a', display: 'block' }}>{c.patient_name}</strong>
                                    <span style={{ background: c.status === "Pending" ? '#fef3c7' : '#e0f2fe', color: c.status === "Pending" ? '#d97706' : '#0284c7', padding: '2px 8px', borderRadius: '12px', fontSize: '0.75rem', fontWeight: 600 }}>{c.status}</span>
                                </div>
                                <div style={{ fontSize: '0.85rem', color: '#64748b', display: 'flex', flexDirection: 'column', gap: '4px' }}>
                                    <span>ID: {c.patient_id} • 📞 {c.patient_phone || "—"}</span>
                                    <span>Teeth: {c.teeth || "N/A"} • {new Date(c.created_at).toLocaleDateString()}</span>
                                </div>
                                {c.status === "Pending" && (
                                    <div style={{ marginTop: '12px' }}>
                                        <Button variant="outline" size="sm" fullWidth onClick={() => markInProgress(c.id)}>
                                            Mark In Progress
                                        </Button>
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
}
